import { useEffect, useState } from "react";
import CustomBlockButton from "../../../../../../../../../components/button/CustomBlockButton";
import { CustomDialog } from "../../../../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { LucideArrowUpToLine, LucideEdit, LucideFileDown, LucidePlus, LucideTrash, LucideTrash2 } from "lucide-react";
import { CustomLabelInput } from "../../../../../../../../../components/input/CustomLabelInput";
import { AnimatePresence, motion } from "framer-motion";
import { customToast } from "../../../../../../../../../components/toast/custom-react-toastify/v1";
import { useDeletePurchaseInfoMutation, useUpdatePurchaseInfosMutation } from "../../../../../../Data/purchaseInfosReactQuery/PurchaseInfosReactQuery";

const StyledBody = styled.div`
    padding: 10px;
    min-height: 100vh;
`;

const StyledPurchaseRoute = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;

    .purchase-route-option{
        padding: 5px 10px;
        border: none;
        border-radius: 5px;
        background-color: var(--backgroundField);
        cursor: pointer;
        transition: background 0.2s;
        font-weight: 500;


        &.selected{
            background-color: #333;
            color: #fff;
            font-weight: 600;
        }

        &:hover{
            box-shadow: var(--shadow-sm);
            /* scale: 1.02; */
        }
    }
`;

const StyledOthersSection = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    button{
        width: 32px;
        height: 32px;
        border-radius: 5px;
        border: 1px solid #333;
        color: #333;
    }
`;

const StyledPurchaseInfoList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 14px;

    h3{
        margin: 0;
    }
`;

const PurchaseInfoItem = styled.div`
    background: #fff;
    border: 1px solid var(--borderColor);
    border-radius: 8px;
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    position: relative;
    box-shadow: var(--shadow-sm);
    transition: box-shadow .15s, transform .15s;

    &:hover{
        box-shadow: var(--shadow-md);
        /* transform: translateY(-2px); */
    }

    .row{
        font-size: 13px;
        line-height: 1.4;
        display: flex;
        gap: 8px;
        flex-wrap: wrap;

        &.eventButtons{
            justify-content: flex-end;
            align-items: center;
            gap: 15px;

            .defaultTag{
                background: var(--soft);
                color: var(--soft-foreground);
                font-size: 11px;
                padding: 4px 8px;
                border-radius: 20px;
                font-weight: 600;
                display: inline-flex;
                align-items: center;
                gap: 4px;
                cursor: pointer;

                &:hover{
                    background: var(--soft-hover);
                    box-shadow: var(--shadow-sm);
                }
            }

            .icon{
                cursor: pointer;

                &:hover{
                    transform: scale(1.1);
                }
            }
        }

        strong{
            font-weight: 600;
            color: #333;
            min-width: 74px;
        }

        a{
            color: #2563eb;
            text-decoration: none;
            max-width: 100%;
            overflow-wrap: anywhere;

            &:hover{
                text-decoration: underline;
            }
        }
    }

    .top-bar{
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
        margin-bottom: 4px;

        .badge{
            background: #f1f5f9;
            color: #334155;
            font-size: 11px;
            padding: 4px 8px;
            border-radius: 20px;
            font-weight: 600;
            display: inline-flex;
            align-items: center;
            gap: 4px;

            &.route{
                background: #eef2ff;
                color: #3730a3;
            }
        }

        .memo{
            font-size: 11px;
            background: #fff8e1;
            color: #8a6d00;
            padding: 3px 8px;
            border-radius: 4px;
            line-height: 1.3;
        }
    }
`;

const StyledDeletePurchaseInfoItem = styled.div`
    background: #fff;
    border: 1px solid var(--borderColor);
    border-radius: 8px;
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    position: relative;
    box-shadow: var(--shadow-sm);
    transition: box-shadow .15s, transform .15s;

    &:hover{
        box-shadow: var(--shadow-md);
        /* transform: translateY(-2px); */
    }

    .notice{
        font-size: 16px;
        color: #333;
        font-weight: 500;
        word-break: keep-all;
    }

    .button-box{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        gap: 8px;
        margin-top: 10px;

        button{
            width: 100px;
            border-radius: 5px;
            height: 40px;
            font-size: 13px;
            font-weight: 600;

            &.cancel{
                background: var(--cancel);
                color: var(--cancel-foreground);
                border: 1px solid var(--borderColor);
            }

            &.destructive{
                background: var(--destructive);
                color: var(--destructive-foreground);
                border: 1px solid var(--destructive);
            }
        }
    }
`;

const StyledUpdatePurchaseInfoItem = styled.div`
    background: #fff;
    border: 1px solid var(--borderColor);
    border-radius: 8px;
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    position: relative;
    box-shadow: var(--shadow-sm);
    transition: box-shadow .15s, transform .15s;

    &:hover{
        box-shadow: var(--shadow-md);
        /* transform: translateY(-2px); */
    }

    .form-field{
        display: flex;
        flex-direction: column;
        gap: 20px;

        .input-box{
            input{
                background-color: #fff;
                border-color: #efefef;
                border-radius: 5px;

                &:focus{
                    border-color: #333;
                }
            }
        }
    }

    .purchaseRouteOptions{
        display: flex;
        flex-direction: row;
        gap: 10px;

        .purchase-route-option{
            padding: 5px 10px;
            border: none;
            border-radius: 5px;
            background-color: var(--backgroundField);
            cursor: pointer;
            transition: background 0.2s;
            font-weight: 500;


            &.selected{
                background-color: #333;
                color: #fff;
                font-weight: 600;
            }

            &:hover{
                box-shadow: var(--shadow-sm);
                /* scale: 1.02; */
            }
        }
    }

    .footerButtons-box{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        gap: 8px;
        button{
            width: 100px;
            border-radius: 5px;
            height: 40px;
            font-size: 13px;
            font-weight: 600;

            &.cancel{
                background: var(--cancel);
                color: var(--cancel-foreground);
                border: 1px solid var(--borderColor);
            }

            &.primary{
                background: var(--primary);
                color: var(--primary-foreground);
                border: 1px solid var(--primary);
            }
        }
    }
`;

export function FragmentDefault({
    onClose,
    targetPurchaseInfos,
    productOptionDetail,
    PURCHASE_ROUTE_OPTIONS,
    setViewType,
    ableToSelect = false,
    onSelect = () => { }
}) {
    const [selectedPurchaseRoute, setSelectedPurchaseRoute] = useState('ALL');

    const defaultPurchaseInfo = targetPurchaseInfos?.find(info => info.defaultFlag);
    return (
        <>
            <CustomDialog.Header style={{ padding: 10 }}>
                <CustomDialog.Header.Fake />
                <CustomDialog.Header.Title>
                    <div className='text-center'>
                        <span>구매정보</span>
                        <div className='font-extrabold text-lg mt-1'>
                            {productOptionDetail?.productDto?.name} / {productOptionDetail?.productOptionDto?.name}
                        </div>
                    </div>
                </CustomDialog.Header.Title>
                <CustomDialog.Header.Close onClick={() => onClose()} />
            </CustomDialog.Header>
            <StyledBody>
                <StyledPurchaseInfoList>
                    {ableToSelect &&
                        <CustomBlockButton
                            type='button'
                            style={{ width: '200px', background: '#fff', color: 'var(--cancel-foreground)', borderRadius: 5, border: '1px solid #333', fontWeight: 600 }}
                            onClick={() => { onSelect(null); }}
                        >
                            선택 미지정
                        </CustomBlockButton>
                    }
                    {defaultPurchaseInfo &&
                        <>
                            <h3># Default</h3>
                            <PurchaseInfoItemComponent
                                purchaseInfo={defaultPurchaseInfo}
                                PURCHASE_ROUTE_OPTIONS={PURCHASE_ROUTE_OPTIONS}
                                ableToSelect={ableToSelect}
                                onSelect={onSelect}
                            />
                            <div></div>
                        </>
                    }
                    <StyledPurchaseRoute>
                        {PURCHASE_ROUTE_OPTIONS?.map(purchaseRouteOption => {
                            const isSelected = selectedPurchaseRoute === purchaseRouteOption.value;
                            return (
                                <div
                                    key={purchaseRouteOption.value}
                                    className={`purchase-route-option ${isSelected ? 'selected' : ''}`}
                                    onClick={() => setSelectedPurchaseRoute(purchaseRouteOption.value)}
                                >
                                    {purchaseRouteOption.label}
                                </div>
                            )
                        })}
                    </StyledPurchaseRoute>
                    <StyledOthersSection>
                        <h3># Others</h3>
                        <CustomBlockButton
                            type='button'
                            onClick={() => setViewType('ADD')}
                        >
                            <LucidePlus size={20} />
                        </CustomBlockButton>
                        <CustomBlockButton
                            type='button'
                            onClick={() => setViewType('LOAD')}
                        >
                            <LucideFileDown size={20} />
                        </CustomBlockButton>
                    </StyledOthersSection>
                    {targetPurchaseInfos
                        ?.filter(purchaseInfo => (selectedPurchaseRoute === 'ALL' || purchaseInfo.purchaseRoute === selectedPurchaseRoute) && purchaseInfo.defaultFlag !== true)
                        .map(purchaseInfo => {
                            return (
                                <PurchaseInfoItemComponent
                                    key={purchaseInfo.uuid}
                                    purchaseInfo={purchaseInfo}
                                    defaultPurchaseInfo={defaultPurchaseInfo}
                                    PURCHASE_ROUTE_OPTIONS={PURCHASE_ROUTE_OPTIONS}
                                    ableToSelect={ableToSelect}
                                    onSelect={onSelect}
                                />
                            )
                        })
                    }
                </StyledPurchaseInfoList>

            </StyledBody>
        </>
    );
}

function PurchaseInfoItemComponent({
    purchaseInfo,
    defaultPurchaseInfo,
    PURCHASE_ROUTE_OPTIONS,
    ableToSelect = false,
    onSelect = () => { }
}) {
    const [viewMode, setViewMode] = useState('VIEW'); // VIEW, DELETE
    const thisPurchaseRouteOption = PURCHASE_ROUTE_OPTIONS.find(option => option.value === purchaseInfo.purchaseRoute);

    const [editablePurchaseInfo, setEditablePurchaseInfo] = useState(null);

    const updatePurchaseInfosMutation = useUpdatePurchaseInfosMutation();
    const deletePurchaseInfoMutation = useDeletePurchaseInfoMutation();

    useEffect(() => {
        if (viewMode === 'EDIT') {
            setEditablePurchaseInfo(purchaseInfo);
        } else {
            setEditablePurchaseInfo(null);
        }
    }, [viewMode]);

    const handleSubmitUpdate = async () => {
        if (!editablePurchaseInfo?.name || editablePurchaseInfo?.name?.length < 1 || editablePurchaseInfo?.name?.length > 100) {
            customToast.error('구매정보는 1자 이상 100자 이하로 입력해주세요.');
            return;
        }

        updatePurchaseInfosMutation.mutate({
            body: {
                payload: [{ ...editablePurchaseInfo }]
            }
        }, {
            onSuccess: () => {
                setViewMode('VIEW');
            }
        })
    }

    const handleChangeToDefault = async () => {
        if (purchaseInfo.defaultFlag) {
            customToast.info('이미 Default 상태입니다.');
            return;
        }

        let payload = [];
        if (defaultPurchaseInfo) {
            payload.push({
                ...defaultPurchaseInfo,
                defaultFlag: false
            });
        }
        payload.push({
            ...purchaseInfo,
            defaultFlag: true
        });

        updatePurchaseInfosMutation.mutate({
            body: {
                payload: [...payload]
            }
        })
    }

    const handleDeleteOne = async () => {
        deletePurchaseInfoMutation.mutate({
            uuid: purchaseInfo.uuid
        }, {
            onSuccess: () => {
                setViewMode('VIEW');
            }
        })
    }

    // 페이드 애니메이션 variants 정의
    const fadeInOutVariants = {
        initial: { opacity: 0, y: 10 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: -10 },
    };
    return (
        <>
            <div>
                <AnimatePresence mode="wait">
                    {/* VIEW Mode */}
                    {viewMode === 'VIEW' &&
                        <motion.div
                            key="view-mode"
                            variants={fadeInOutVariants}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            layout
                        >
                            <PurchaseInfoItem>
                                <div className='top-bar'>
                                    <span className='badge route'>{
                                        PURCHASE_ROUTE_OPTIONS.find(option => option.value === purchaseInfo.purchaseRoute)?.label
                                    }</span>
                                    {purchaseInfo.name && (
                                        <span className='memo'>{purchaseInfo.name}</span>
                                    )}
                                    {purchaseInfo.defaultFlag &&
                                        <span className='badge'># Default</span>
                                    }
                                </div>
                                <div className='row'>
                                    <strong>구매URL</strong>
                                    <a href={purchaseInfo.purchaseUrl} target="_blank" rel="noopener noreferrer">
                                        {purchaseInfo.purchaseUrl}
                                    </a>
                                </div>
                                {thisPurchaseRouteOption?.value === '1688' &&
                                    <>
                                        <div className='row'>
                                            <strong>1688 오퍼</strong>
                                            <span>{purchaseInfo.offerId && <>(ID: {purchaseInfo.offerId})</>} {purchaseInfo.offerName && purchaseInfo.offerName}</span>
                                        </div>
                                        <div className='row'>
                                            <strong>1688 스펙</strong>
                                            <span>{purchaseInfo.specId && <>(ID: {purchaseInfo.specId})</>} {purchaseInfo.specName && purchaseInfo.specName}</span>
                                        </div>
                                    </>
                                }
                                <div className='row eventButtons'>
                                    {!purchaseInfo.defaultFlag &&
                                        <div className='defaultTag' onClick={() => handleChangeToDefault()}><LucideArrowUpToLine size={10} /> Default</div>
                                    }
                                    <LucideEdit
                                        size={20}
                                        className='icon'
                                        onClick={() => setViewMode('EDIT')}
                                    />
                                    <LucideTrash2
                                        size={20}
                                        className='icon'
                                        color='var(--destructive)'
                                        onClick={() => setViewMode('DELETE')}
                                    />
                                </div>
                                {ableToSelect &&
                                    <div className='row' style={{ marginTop: '10px' }}>
                                        <CustomBlockButton
                                            type='button'
                                            style={{ background: '#333', color: '#fff', borderRadius: 5, border: 'none', fontWeight: 600 }}
                                            onClick={() => onSelect(purchaseInfo)}
                                        >
                                            선택
                                        </CustomBlockButton>
                                    </div>
                                }
                            </PurchaseInfoItem>
                        </motion.div>
                    }
                    {/* DELETE Mode */}
                    {viewMode === 'DELETE' &&
                        <motion.div
                            key="delete-mode"
                            variants={fadeInOutVariants}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            layout
                        >
                            <StyledDeletePurchaseInfoItem
                                className={`delete-mode-box`}
                            >
                                <div className='notice'>
                                    해당 데이터를 정말로 삭제하시겠습니까?
                                </div>
                                <div className='button-box'>
                                    <CustomBlockButton
                                        type='button'
                                        className='destructive'
                                        onClick={() => { handleDeleteOne(); }}
                                    >
                                        삭제
                                    </CustomBlockButton>
                                    <CustomBlockButton
                                        type='button'
                                        className='cancel'
                                        onClick={() => setViewMode('VIEW')}
                                    >
                                        취소
                                    </CustomBlockButton>
                                </div>
                            </StyledDeletePurchaseInfoItem>
                        </motion.div>
                    }

                    {/* EDIT Mode */}
                    {viewMode === 'EDIT' && editablePurchaseInfo &&
                        <StyledUpdatePurchaseInfoItem>
                            <form className='form-field' onSubmit={(e) => {
                                e.preventDefault();
                                handleSubmitUpdate();
                            }}>
                                <div className='purchaseRouteOptions'>
                                    {PURCHASE_ROUTE_OPTIONS?.filter(r => r.value !== 'ALL')?.map(purchaseRouteOption => {
                                        const isSelected = editablePurchaseInfo?.purchaseRoute === purchaseRouteOption.value;
                                        return (
                                            <div
                                                key={purchaseRouteOption.value}
                                                className={`purchase-route-option ${isSelected ? 'selected' : ''}`}
                                                onClick={() => {
                                                    setEditablePurchaseInfo(prev => {
                                                        return {
                                                            ...prev,
                                                            purchaseRoute: purchaseRouteOption.value
                                                        }
                                                    })
                                                }}
                                            >
                                                {purchaseRouteOption.label}
                                            </div>
                                        )
                                    })}
                                </div>
                                <CustomLabelInput
                                    type="text"
                                    className='input-box'
                                >
                                    <CustomLabelInput.Input
                                        type='text'
                                        value={editablePurchaseInfo?.name || ''}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setEditablePurchaseInfo(prev => {
                                                return {
                                                    ...prev,
                                                    name: value
                                                }
                                            })
                                        }}
                                    />
                                    <CustomLabelInput.Label><span style={{ color: 'var(--destructive)' }}>*</span> 구매정보 (1~100자 입력)</CustomLabelInput.Label>
                                </CustomLabelInput>
                                <CustomLabelInput
                                    type="text"
                                    className='input-box'
                                >
                                    <CustomLabelInput.Input
                                        type='text'
                                        value={editablePurchaseInfo?.purchaseUrl || ''}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setEditablePurchaseInfo(prev => {
                                                return {
                                                    ...prev,
                                                    purchaseUrl: value
                                                }
                                            })
                                        }}
                                    />
                                    <CustomLabelInput.Label>구매 URL</CustomLabelInput.Label>
                                </CustomLabelInput>
                                {editablePurchaseInfo?.purchaseRoute === '1688' && (
                                    <>
                                        <CustomLabelInput
                                            type="text"
                                            className='input-box'
                                        >
                                            <CustomLabelInput.Input
                                                type='text'
                                                value={editablePurchaseInfo?.offerId || ''}
                                                onChange={(e) => {
                                                    const raw = e.target.value;
                                                    // 개행 기준 분리
                                                    const parts = raw.split(/\r?\n/);
                                                    const offerPart = parts[0] ?? '';
                                                    const specPart = parts[1]?.trim();
                                                    setEditablePurchaseInfo(prev => {
                                                        return {
                                                            ...prev,
                                                            offerId: offerPart.trim(),
                                                            specId: specPart ? specPart : prev.specId // 두 번째 줄이 있으면 specId 갱신
                                                        }
                                                    });
                                                }}
                                                onPaste={(e) => {
                                                    // 붙여넣기 시 여러 줄 빠르게 처리
                                                    const text = (e.clipboardData || window.clipboardData).getData('text');
                                                    if (text.includes('\n')) {
                                                        e.preventDefault();
                                                        const [offerPart, specPart] = text.split(/\r?\n/);
                                                        setEditablePurchaseInfo(prev => ({
                                                            ...prev,
                                                            offerId: (offerPart || '').trim(),
                                                            specId: (specPart || '').trim()
                                                        }));
                                                    }
                                                }}
                                            />
                                            <CustomLabelInput.Label>offerId (여기다 붙여넣기)</CustomLabelInput.Label>
                                        </CustomLabelInput>
                                        <CustomLabelInput
                                            type="text"
                                            className='input-box'
                                        >
                                            <CustomLabelInput.Input
                                                type='text'
                                                value={editablePurchaseInfo?.specId || ''}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setEditablePurchaseInfo(prev => {
                                                        return {
                                                            ...prev,
                                                            specId: value
                                                        }
                                                    })
                                                }}

                                            />
                                            <CustomLabelInput.Label>specId</CustomLabelInput.Label>
                                        </CustomLabelInput>
                                        <CustomLabelInput
                                            type="text"
                                            className='input-box'
                                        >
                                            <CustomLabelInput.Input
                                                type='text'
                                                value={editablePurchaseInfo?.offerName || ''}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setEditablePurchaseInfo(prev => {
                                                        return {
                                                            ...prev,
                                                            offerName: value
                                                        }
                                                    })
                                                }}
                                            />
                                            <CustomLabelInput.Label>offer 이름</CustomLabelInput.Label>
                                        </CustomLabelInput>
                                        <CustomLabelInput
                                            type="text"
                                            className='input-box'
                                        >
                                            <CustomLabelInput.Input
                                                type='text'
                                                value={editablePurchaseInfo?.specName || ''}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setEditablePurchaseInfo(prev => {
                                                        return {
                                                            ...prev,
                                                            specName: value
                                                        }
                                                    })
                                                }}
                                            />
                                            <CustomLabelInput.Label>spec 이름</CustomLabelInput.Label>
                                        </CustomLabelInput>
                                    </>
                                )}
                                <div className='footerButtons-box'>
                                    <CustomBlockButton
                                        type='button'
                                        className='cancel'
                                        onClick={() => setViewMode('VIEW')}
                                    >
                                        취소
                                    </CustomBlockButton>
                                    <CustomBlockButton
                                        type='submit'
                                        className='primary'
                                    >
                                        저장
                                    </CustomBlockButton>
                                </div>
                            </form>
                        </StyledUpdatePurchaseInfoItem>
                    }
                </AnimatePresence>
            </div>
        </>
    );
}